import { useRecordContext, useTranslate } from 'react-admin';
import { Typography } from '@mui/material';

export const ParameterSubsetTypeField = () => {
    const record = useRecordContext();
    const translate = useTranslate();

    if (!record?.type) {
        return (
            <Typography variant='body2' className='gray'>
                —
            </Typography>
        );
    }

    return <Typography variant='body2'>{translate(`resources.parameter.subsetTypes.${record.type}`, { _: record.type })}</Typography>;
};
